import React from "react";
import SVGStatusFailLight from "../../svg/SVGStatusFailLight";
import SVGStatusFailDark from "../../svg/SVGStatusFailDark";

const EmptyData = ({themeColor}) => {
    return <div className="paymentInfo">
        <main style={{textAlign: 'center'}}>
            <p className="title">Невідома заявка</p>
            <div style={{margin: '20px 0'}}>
                {themeColor === 'light' ? SVGStatusFailLight : SVGStatusFailDark}
            </div>
        </main>
    </div>
}

export default EmptyData